module.exports = __webpack_public_path__ + "static/img/7一种具有安全防护装置的切管机.cc70f394.jpg";